import {Form, InputGroup} from "@themesberg/react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";
import PropTypes from 'prop-types';
import {cleanNonNumeric} from "enqc-utilities/src/utils/Utilities";

export default class NumberInput extends React.Component{

    state = {}

    constructor(props) {
        super(props);
        let {autoFocus, value} = this.props
        this.inputRef = React.createRef(null)
        this.setState({autoFocus, value})
    }

    componentDidMount() {
        let {autoFocus} = this.state
        if(autoFocus){
            this.focus()
        }
    }

    focus(){
        if(this.inputRef && this.inputRef.current){
            this.inputRef.current.focus()
        }
    }

    render() {
        let {value} = this.state
        let {id, placeholder, label, centered, danger, maxLength, readOnly, icon, isError, errorMessage} = this.props
        if(!id){
            id = "text"
        }
        if(!label){
            label = ""
        }
        if(!placeholder){
            placeholder = label
        }
        let style = this.props.style ?this.props.style:{}
        style = {
            appearance: 'textfield',
            MozAppearance: 'textfield',
            WebkitAppearance: 'none',
            ...style}
        style = style
        return (
            <Form.Group id={id}  className={"mb-4 "+(this.props.clickable?" clickable-input ":" "+(centered?" text-center ":""))}>
                {label&&(
                    <Form.Label>{label}</Form.Label>
                )}
                <InputGroup className={(this.props.clickable?" clickable-input ":"")+(danger?" text-danger ":" text-dark ")}>
                    {icon&&(
                        <InputGroup.Text style={{borderColor:(isError?'#FA5252':'')}}>
                            <FontAwesomeIcon icon={icon} />
                        </InputGroup.Text>
                    )}
                    <Form.Control
                        required={this.props.required}
                        type="text"
                        inputMode="numeric"
                        placeholder={placeholder}
                        onChange={(e)=>{
                            if(this.props.onChange){
                                let value = cleanNonNumeric(e.target.value)
                                this.setState({value}, () => {
                                    this.props.onChange(value)
                                })
                            }
                        }}
                        onKeyDown={e=>{
                            if(e.key==='Enter' && this.props.onEnter){
                                e.preventDefault()
                                let value = cleanNonNumeric(e.target.value)
                                this.props.onEnter(value)
                            }
                        }}
                        isInvalid={isError}
                        value={value}
                        readOnly={readOnly}
                        onClick={this.props.onClick}
                        style={style}
                        ref={this.inputRef}
                        maxLength={maxLength}
                        className={(this.props.clickable?" clickable-input ":" ")+(centered?" text-center ":" ")+(danger?" text-danger ":" text-dark ")}
                    />
                </InputGroup>
                {isError&&(
                    <Form.Control.Feedback type="invalid" style={{display:'unset', position:'absolute'}}>{errorMessage?errorMessage:placeholder}</Form.Control.Feedback>
                )}
            </Form.Group>
        );
    }
}
NumberInput.propTypes = {
    label:PropTypes.string,
    value:PropTypes.string,
    placeholder:PropTypes.string,
    icon:PropTypes.any,
    centered:PropTypes.bool,
    required:PropTypes.bool,
    readOnly:PropTypes.bool,
    onChange:PropTypes.func,
    onEnter:PropTypes.func,
    isError:PropTypes.bool,
    errorMessage:PropTypes.string,
    clickable:PropTypes.bool,
    autoFocus:PropTypes.bool,
    maxLength:PropTypes.number,
    danger:PropTypes.bool,
    onClick:PropTypes.func

}